import Section from "@/Components/LayoutComponents/Section";
import { toWebp } from "@/utils/common";
import Image from "next/image";
import React from "react";

const ContactRow = ({ label, email, number }: any) => {
  if (!email && !number) return null;

  return (
    <div>
      <p className="text-subtitle-1 font-regular text-secondary-text">
        {label}
      </p>
      <div className="flex justify-start md:flex-nowrap flex-wrap items-center gap-3 mt-4">
        {email && (
          <a className="text-secondary-text text-subtitle-1 font-bold">
            {email}
          </a>
        )}

        {email && number && (
          <span className="text-secondary-text text-subtitle-1 font-bold">
            |
          </span>
        )}

        {number && (
          <a className="text-secondary-text text-subtitle-1 font-bold">
            {number}
          </a>
        )}
      </div>
    </div>
  );
};

const OfficeCardBlock = ({ data, color = "blue" }: any) => {
  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL;

  if (!data) return null;

  return (
    (
      <div
        className={`border ${color === "green" ? "border-green-100" : "border-border"} bg-white`}
      >
        <div className="grid grid-cols-1 xl:grid-cols-2 xl:gap-[105px] md:gap-[32px] gap-[16px] xl:pt-10 xl:px-8 md:pt-[30px] md:px-[24px] pt-[32px] px-[20px]">
          <div>
            <p
              className={`text-${color}-500 text-subtitle-3 font-bold uppercase py-2 pb-1 px-3 bg-${color}-50 w-fit mb-4`}
            >
              {data.country}
            </p>
            <h2 className={`text-heading-2 font-bold text-${color}-500`}>
              {data.Location}
            </h2>
            <p className="text-subtitle-1 font-regular text-secondary-text mt-4">
              {data.Address}
            </p>
          </div>

          <div className="w-fit xl:ml-auto xl:space-y-8 md:space-y-8 space-y-4">
            <ContactRow
              label="For Business"
              email={data.business_email}
              number={data.business_number}
            />

            <ContactRow
              label="For Careers"
              email={data.career_email}
              number={data.career_number}
            />
          </div>
        </div>

        <div className="flex justify-center items-center xl:mt-[103px] md:mt-[46px] mt-[40px] max-w-full">
          <Image
            src={toWebp(`${baseUrl}${data?.image?.data?.attributes?.url}`)}
            alt={data.Location}
            quality={100}
            width={615}
            height={246}
            className="lg:w-1/2 w-full max-w-full h-auto object-cover object-bottom lg:flex-[0_0_50%] flex-1"
          />
          <Image
            src={toWebp(`${baseUrl}${data?.image?.data?.attributes?.url}`)}
            alt={data.Location}
            quality={100}
            width={615}
            height={246}
            className="w-1/2 max-w-full h-auto object-cover object-bottom hidden lg:block flex-[0_0_50%]"
          />
        </div>
      </div>
    )
  );
};

const ContactSection = ({ data }: { data: any }) => {
  const OfficeCard = data?.OfficeCard || [];

  return (
    <Section className="relative z-10 xl:mt-[-82px] md:mt-[-70px] mt-[-84px] pt-0!">
      <div className="container space-y-[60px]">
        {OfficeCard?.map((item: any, index: number) => (
          <OfficeCardBlock
            key={index}
            data={item}
            color={index % 2 === 0 ? "blue" : "green"}
          />
        ))}
      </div>
    </Section>
  );
};

export default ContactSection;
